import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@coolblue-development/freddy';
export default function ProductTitleEyebrow({ children }) {
    return (_jsx(Typography, { component: "span", variant: "caption", color: "base", children: children }));
}
//# sourceMappingURL=Eyebrow.js.map